export default "__VITE_ASSET__BacyjJN6__"